export default "__VITE_ASSET__Cc20KEuU__"